<style>
    #friseContainer{
        scroll-behavior: smooth;
    }
</style>
<template>
  <transition leave-active-class="duration-200">
    <div
      v-if="opened"
      class="h-screen z-50 fixed bottom-0 px-4 inset-0 sm:p-0 flex justify-center items-center"
    >
      <!-- Background modal -->
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="opened"
          class="fixed inset-0 transition-opacity"
          @click="close"
        >
          <div class="absolute inset-0 bg-indigo-600 bg-opacity-85" />
        </div>
      </transition>
      <!-- FIN Background modal -->

      <!-- Content modal -->
      <transition
        enter-active-class="ease-out duration-300"
        enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        enter-to-class="opacity-100 translate-y-0 sm:scale-100"
        leave-active-class="ease-in duration-200"
        leave-class="opacity-100 translate-y-0 sm:scale-100"
        leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      >
        <div
          class="ios-scroll bg-white rounded-lg pt-5 sm:py-6 pb-4 overflow-y-scroll lg:overflow-y-hidden overflow-x-scroll h-11/12 shadow-xl transform transition-all w-full lg:w-11/12 border-pop"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal-headline"
          id="friseContainer"

          @mousemove="scroll"
          @mousedown="setMousePositionX"
          @mouseup="isScrollOnDrag=false;"
          @mousewheel="updateDisplayButtons"
          @scroll="updateDisplayButtons"
        >
          <div
            class="sticky left-0 group z-50 mr-6"
            @click.stop="close"
          >
            <div
              class="cursor-pointer block w-max absolute right-5 top-5
                        rounded-full p-2
                        bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25
                        transition ease-in-out duration-500
                        group-hover:text-white group-hover:bg-pink-600"
            >
              <icon name="close" />
            </div>
          </div>
          <div class="sticky left-0 mt-14 z-50">
            <h3 class="text-gray-900">
              Frise chronologique
            </h3>
            <div
              v-if="friseDatas.length > 0"
              class="cursor-pointer block w-max absolute top-10 md:top-0 right-1/12"
              v-click-outside="hideFilter"
            >
              <action-button
                class="text-base"
                border-color="border-transparent"
                text-color="text-gray-900"
                bg-color="bg-indigo-300"
                bg-color-square="bg-indigo-100"
                icon-color="text-indigo-600"
                libelle="Filtrer les évènements"
                icon="options"
                :responsive="true"
                @clickAction="showFilter()"
              />

              <div
                class="shadow-gray px-5 py-3 rounded-xl mt-1 w-max right-0 absolute bg-white"
                v-if="isFilterDisplayed"
              >
                <checkbox-indigo
                  libelle="Tout"
                  :value="Object.values(friseFilter).every(value => value)"
                  :is-small="true"
                  size-libelle="text-sm"
                  @input="checkAll()"
                />
                <div class="ml-5">
                  <checkbox-indigo
                    v-for="(isDisplayed, type) in friseFilter"
                    :key="type"
                    :libelle="type"
                    :value="isDisplayed"
                    :is-small="true"
                    size-libelle="text-sm"
                    @input="(newValue) => {friseFilter[type] = newValue}"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- BEGIN Frise chronologique -->
          <div
            v-if="friseDatas.length > 0 && filteredFriseDatas.filter(f => f.type != 'empty').length > 0"
            class="my-28"
            style="cursor: grab;"
          >
            <div class="flex flex-nowrap min-w-max pt-44">
              <!-- BEGIN scroll left button -->
              <div class="hidden lg:block sticky left-0 z-40 bg-white py-full px-5 -mt-full w-max">
                <transition
                  enter-active-class="ease-out duration-300"
                  enter-class="opacity-0"
                  enter-to-class="opacity-100"
                  leave-active-class="ease-in duration-300"
                  leave-class="opacity-100"
                  leave-to-class="opacity-0"
                >
                  <div
                    v-if="isScrollLeftDisplay"
                    @click="scrollLeft"
                    class="w-10 h-10 flex items-center justify-center rounded-full bg-pink-600 text-white -mt-4 cursor-pointer"
                  >
                    <icon name="chevron-left" />
                  </div>
                  <div
                    v-else
                    class="w-10 h-10 flex rounded-full -mt-4"
                  />
                </transition>
              </div>
              <!-- END scroll left button -->
              <div class="bg-indigo-600 h-0.5 w-full relative" />
              <div class="bg-indigo-600 h-0.5 w-48 relative" />
              <div
                v-for="(year, numYear) in filteredFriseDatas"
                :key="numYear"
              >
                <div class="bg-indigo-600 flex h-0.5 w-40 2xl:w-56 relative">
                  <div v-if="year && year.direction">
                    <div
                      class="absolute -left-10 text-base"
                      :class="{'bottom-1.5' : year.direction == 'up', 'top-1.5' : year.direction == 'down'}"
                    >
                      {{ year.value }}
                    </div>
                    <!-- BEGIN event -->
                    <div
                      class="absolute"
                      :class="{'-bottom-1.5' : year.direction == 'up', '-top-1' : year.direction == 'down'}"
                    >
                      <!-- BEGIN when event show up -->
                      <div
                        v-if="year.direction == 'up'"
                        class="flex flex-col relative"
                      >
                        <div
                          class="pb-2 bg-white absolute -top-14"
                          :class="{
                            'z-30': numDisplayedEvent == numYear,
                            '-left-5': (numYear < friseDatas.length-2 || (numYear >= friseDatas.length-2 && numDisplayedEvent != numYear)),
                            'self-start -right-5' : (numYear >= friseDatas.length-2 && numDisplayedEvent == numYear)
                          }"
                        >
                          <!-- BEGIN single event -->
                          <evenement-frise
                            v-if="year.type !='multi'"
                            :year="year"
                            :num-year="numYear"
                            :icon="decorationByEvent[year.type][year.event.type].icon"
                            :background-color="decorationByEvent[year.type][year.event.type].bg"
                            :text-color="decorationByEvent[year.type][year.event.type].color"
                            :is-displayed-event="numDisplayedEvent == numYear"
                            @displayEvent="displayEvent(numYear, 'event'+numYear)"
                            @closeEvent="closeEvent"
                          />
                          <!-- END single event -->

                          <!-- BEGIN multi event -->
                          <multi-evenement-frise
                            v-if="year.type =='multi'"
                            :year="year"
                            :num-year="numYear"
                            :is-displayed-event="numDisplayedEvent == numYear"
                            @displayEvent="displayEvent(numYear, 'event'+numYear)"
                            @closeEvent="closeEvent"
                          />
                          <!-- END multi event -->
                        </div>
                        <div
                          v-if="year.type !='multi'"
                          :class="'h-32 w-px self-center '+decorationByEvent[year.type][year.event.type].line"
                        />
                        <div
                          v-if="year.type !='multi'"
                          :class="'self-center '+decorationByEvent[year.type][year.event.type].border+' border '+decorationByEvent[year.type][year.event.type].bg+' rounded-full w-3 h-3'"
                        />

                        <div
                          v-if="year.type =='multi'"
                          :class="'h-32 w-px self-center '+decorationByEvent[year.event[0].type][year.event[0].event.type].line"
                        />
                        <div
                          v-if="year.type =='multi'"
                          :class="'self-center '+decorationByEvent[year.event[0].type][year.event[0].event.type].border+' border '+decorationByEvent[year.event[0].type][year.event[0].event.type].bg+' rounded-full w-3 h-3'"
                        />
                      </div>
                      <!-- END when event show up -->

                      <!-- BEGIN when event show down -->
                      <div
                        v-if="year.direction == 'down'"
                        class="flex flex-col relative"
                      >
                        <div
                          v-if="year.type !='multi'"
                          :class="'self-center '+decorationByEvent[year.type][year.event.type].border+' border '+decorationByEvent[year.type][year.event.type].bg+' rounded-full w-3 h-3'"
                        />
                        <div
                          v-if="year.type !='multi'"
                          :class="'h-32 w-px self-center '+decorationByEvent[year.type][year.event.type].line"
                        />

                        <div
                          v-if="year.type =='multi'"
                          :class="'self-center '+decorationByEvent[year.event[0].type][year.event[0].event.type].border+' border '+decorationByEvent[year.event[0].type][year.event[0].event.type].bg+' rounded-full w-3 h-3'"
                        />
                        <div
                          v-if="year.type =='multi'"
                          :class="'h-32 w-px self-center '+decorationByEvent[year.event[0].type][year.event[0].event.type].line"
                        />
                        <div
                          class="pt-2 bg-white absolute -bottom-14"
                          :class="{
                            'z-30': numDisplayedEvent == numYear,
                            '-left-5': (numYear < friseDatas.length-2 || (numYear >= friseDatas.length-2 && numDisplayedEvent != numYear)),
                            'self-start -right-5' : (numYear >= friseDatas.length-2 && numDisplayedEvent == numYear)
                          }"
                        >
                          <!-- BEGIN single event -->
                          <evenement-frise
                            v-if="year.type !='multi'"
                            :year="year"
                            :num-year="numYear"
                            :icon="decorationByEvent[year.type][year.event.type].icon"
                            :background-color="decorationByEvent[year.type][year.event.type].bg"
                            :text-color="decorationByEvent[year.type][year.event.type].color"
                            :is-displayed-event="numDisplayedEvent == numYear"
                            @displayEvent="displayEvent(numYear, 'event'+numYear)"
                            @closeEvent="closeEvent"
                          />
                          <!-- END single event -->

                          <!-- BEGIN multi event -->
                          <multi-evenement-frise
                            v-if="year.type =='multi'"
                            :year="year"
                            :num-year="numYear"
                            :is-displayed-event="numDisplayedEvent == numYear"
                            @displayEvent="displayEvent(numYear, 'event'+numYear)"
                            @closeEvent="closeEvent"
                          />
                          <!-- END multi event -->
                        </div>
                      </div>
                      <!-- END when event show down -->
                    </div>
                    <!-- END event -->
                  </div>
                </div>
              </div>

              <div class="bg-indigo-600 h-0.5 w-full relative" />

              <!-- BEGIN scroll right button -->
              <div class="hidden lg:block float-right sticky right-0 z-40 bg-white py-full px-5 -mt-full w-max">
                <transition
                  enter-active-class="ease-out duration-300"
                  enter-class="opacity-0"
                  enter-to-class="opacity-100"
                  leave-active-class="ease-in duration-300"
                  leave-class="opacity-100"
                  leave-to-class="opacity-0"
                >
                  <div
                    v-if="isScrollRightDisplay"
                    @click="scrollRight"
                    class="w-10 h-10 flex items-center justify-center rounded-full bg-pink-600 text-white -mt-4 cursor-pointer"
                  >
                    <icon name="chevron-right" />
                  </div>
                  <div
                    v-else
                    class="w-10 h-10 flex rounded-full -mt-4"
                  />
                </transition>
              </div>
              <!-- END scroll right button -->
            </div>
          </div>
          <!-- END Frise chronologique -->
          <div
            v-else
            class="flex items-center justify-center h-3/4"
          >
            <h4 class="text-gray-600">
              Il n'y a aucun évènement à afficher
            </h4>
          </div>
        </div>
      </transition>

      <!-- END Content modal -->
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Constants from './../../constants';

import Icon from '../Icon.vue';
import Popup from './../../components/Popup';
import EvenementFrise from './../../components/FriseChronologique/EvenementFrise';
import MultiEvenementFrise from './../../components/FriseChronologique/MultiEvenementFrise';
import ClickOutside from 'vue-click-outside';
import ActionButton from './../../components/ActionButton';
import CheckboxIndigo from './../../components/Inputs/CheckboxIndigo';

export default {
  components:{
    Popup,
    Icon,
    EvenementFrise,
    MultiEvenementFrise,
    ActionButton,
    CheckboxIndigo,
  },

  data(){
    return {
      decorationByEvent: Constants.FRISE_CHRONOLOGIQUE_DECORATION_BY_EVENT,

      numDisplayedEvent:-1,

      isScrollLeftDisplay: false,
      isScrollRightDisplay: true,

      mousePositionX:0,
      isScrollOnDrag: false,

      isFilterDisplayed: false,
    };
  },

  props : {
    opened: Boolean,
  },

  methods: {
    close(){
      this.resetFilter();
      this.$emit('close');
    },
    ...mapMutations({
      SET_INFOSPAGE: 'neopass/SET_INFOSPAGE',
      SET_FRISEFILTER: 'neopass/SET_FRISEFILTER',
    }),

    resetFilter(){
      Object.keys(this.friseFilter).forEach(type => {
        this.friseFilter[type] = true;
      });
    },

    async displayEvent(numEvent, id=null){
      if(this.numDisplayedEvent == numEvent){
        //this.numDisplayedEvent = -1;
      }else{
        this.numDisplayedEvent = numEvent;
        if(id != null){
          let pos = document.getElementById(id);
          pos.scrollIntoView({behavior: 'smooth', inline:'center', block:'nearest'});
          this.updateDisplayButtons();
        }
      }
    },

    closeEvent(){
      this.numDisplayedEvent = -1;
    },

    setScrollLeft(distance){
      let container = document.getElementById('friseContainer');
      container.scrollLeft = container.scrollLeft + distance;
    },
    async scrollLeft() {
      await this.setScrollLeft(-250);
      this.updateDisplayButtons();
    },
    async scrollRight() {
      await this.setScrollLeft(250);
      this.updateDisplayButtons();
    },

    setMousePositionX(e){
      this.isScrollOnDrag=true;
      this.mousePositionX = e.clientX;
    },

    async scroll(e){
      if(this.isScrollOnDrag){
        await this.setScrollLeft(this.mousePositionX-e.clientX);
      }
      this.updateDisplayButtons();
    },

    updateDisplayButtons(){
      let container = document.getElementById('friseContainer');

      this.isScrollLeftDisplay = container.scrollLeft > 0;
      this.isScrollRightDisplay = container.scrollLeft < (container.scrollWidth - container.offsetWidth);
    },

    showFilter(){
      this.isFilterDisplayed = !this.isFilterDisplayed;
    },

    hideFilter(){
      this.isFilterDisplayed = false;
    },

    checkAll(){
      if (Object.values(this.friseFilter).every(value => value)){
        for (const [key, value] of Object.entries(this.friseFilter)) {
          this.friseFilter[key] = false;
        }
      }else{
        for (const [key, value] of Object.entries(this.friseFilter)) {
          this.friseFilter[key] = true;
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      friseDatas : 'neopass/friseDatas',
      friseFilter: 'neopass/friseFilter',
    }),

    filteredFriseDatas: function(){
      let newFriseDatas = [];
      let isUp = true;

      let isFirst = true;

      this.friseDatas.forEach(dataRaw =>{
        let newData = {...dataRaw};

        switch (dataRaw.type) {
        case 'empty':
          newFriseDatas.push(newData);
          break;

        case 'multi':
          let multiEvents = [];
          newData.event.forEach(event => {
            if(this.friseFilter[event.event.type]){
              multiEvents.push(event);
            }
          });
          if(multiEvents.length == 0)
            break;
          if(multiEvents.length > 1)
            newData.event = multiEvents;
          if(multiEvents.length == 1)
            newData = multiEvents[0];
          newData.direction = (isUp) ? 'up' : 'down';
          isUp = !isUp;
          newFriseDatas.push(newData);
          isFirst = false;
          break;

        default:
          if(this.friseFilter[dataRaw.event.type]){
            newData.direction = (isUp) ? 'up' : 'down';
            isUp = !isUp;
            newFriseDatas.push(newData);
            isFirst = false;
          }
          if(!this.friseFilter[dataRaw.event.type] && !isFirst){
            newData.direction = null;
            newData.event = null;
            newData.type = 'empty';
            newFriseDatas.push(newData);
          }
          break;
        }
      });

      return newFriseDatas;
    },
  },

  directives:{
    ClickOutside
  }
};

</script>

<style scoped>
    .ios-scroll{
        -webkit-overflow-scrolling: touch;
    }
</style>
